<template>
  <div class="odor-form-container">
    <div class="p-30px">
      <div class="cancel" @click="cancel()">
        <CustomIcon name="chevron-left"></CustomIcon>Annuler
      </div>
      <div>
        <h2>Remplir le questionnaire</h2>
      </div>
      <div class="localisation-container">
        <div class="grey-area">
          <h3>Localisation - {{ activePoint.properties.no }}</h3>
          <div class="address">{{ activePoint.properties.address }}</div>
        </div>
        <div class="d-flex space-between">
          <div class="grey-area w-48 date-hour">{{ displayDate }}</div>
          <div class="grey-area w-48 date-hour">{{ displayHour }}</div>
        </div>
        <div class="d-flex space-between">
          <div class="grey-area w-48 date-hour d-flex">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M6.25 5.5C6.25 4.85721 6.44061 4.22886 6.79772 3.6944C7.15484 3.15994 7.66242 2.74338 8.25628 2.49739C8.85014 2.25141 9.50361 2.18705 10.134 2.31245C10.7645 2.43785 11.3436 2.74738 11.7981 3.2019C12.2526 3.65643 12.5622 4.23552 12.6876 4.86596C12.813 5.4964 12.7486 6.14986 12.5026 6.74372C12.2566 7.33758 11.8401 7.84516 11.3056 8.20228C10.7711 8.55939 10.1428 8.75 9.5 8.75H3C2.80109 8.75 2.61032 8.67098 2.46967 8.53033C2.32902 8.38968 2.25 8.19891 2.25 8C2.25 7.80109 2.32902 7.61032 2.46967 7.46967C2.61032 7.32902 2.80109 7.25 3 7.25H9.5C9.84612 7.25 10.1845 7.14737 10.4722 6.95507C10.76 6.76278 10.9843 6.48947 11.1168 6.1697C11.2492 5.84993 11.2839 5.49806 11.2164 5.15859C11.1489 4.81913 10.9822 4.50731 10.7374 4.26256C10.4927 4.01782 10.1809 3.85115 9.84141 3.78363C9.50194 3.7161 9.15007 3.75076 8.8303 3.88321C8.51053 4.01567 8.23722 4.23997 8.04493 4.52775C7.85264 4.81554 7.75 5.15388 7.75 5.5V5.857C7.75 6.05591 7.67098 6.24668 7.53033 6.38733C7.38968 6.52798 7.19891 6.607 7 6.607C6.80109 6.607 6.61032 6.52798 6.46967 6.38733C6.32902 6.24668 6.25 6.05591 6.25 5.857V5.5ZM14.25 7.5C14.25 6.65943 14.4993 5.83774 14.9663 5.13883C15.4333 4.43992 16.097 3.89519 16.8736 3.57351C17.6502 3.25184 18.5047 3.16768 19.3291 3.33166C20.1536 3.49565 20.9108 3.90042 21.5052 4.4948C22.0996 5.08917 22.5043 5.84645 22.6683 6.67087C22.8323 7.49529 22.7482 8.34982 22.4265 9.12641C22.1048 9.90299 21.5601 10.5668 20.8612 11.0337C20.1623 11.5007 19.3406 11.75 18.5 11.75H2C1.80109 11.75 1.61032 11.671 1.46967 11.5303C1.32902 11.3897 1.25 11.1989 1.25 11C1.25 10.8011 1.32902 10.6103 1.46967 10.4697C1.61032 10.329 1.80109 10.25 2 10.25H18.5C19.0439 10.25 19.5756 10.0887 20.0278 9.78654C20.4801 9.48437 20.8325 9.05488 21.0407 8.55238C21.2488 8.04988 21.3033 7.49695 21.1972 6.9635C21.091 6.43006 20.8291 5.94005 20.4445 5.55546C20.0599 5.17086 19.5699 4.90895 19.0365 4.80284C18.5031 4.69673 17.9501 4.75119 17.4476 4.95933C16.9451 5.16747 16.5156 5.51995 16.2135 5.97218C15.9113 6.42442 15.75 6.9561 15.75 7.5V8C15.75 8.19891 15.671 8.38968 15.5303 8.53033C15.3897 8.67098 15.1989 8.75 15 8.75C14.8011 8.75 14.6103 8.67098 14.4697 8.53033C14.329 8.38968 14.25 8.19891 14.25 8V7.5ZM3.25 14C3.25 13.8011 3.32902 13.6103 3.46967 13.4697C3.61032 13.329 3.80109 13.25 4 13.25H18.5C19.3406 13.25 20.1623 13.4993 20.8612 13.9663C21.5601 14.4333 22.1048 15.097 22.4265 15.8736C22.7482 16.6502 22.8323 17.5047 22.6683 18.3291C22.5043 19.1536 22.0996 19.9108 21.5052 20.5052C20.9108 21.0996 20.1536 21.5044 19.3291 21.6683C18.5047 21.8323 17.6502 21.7482 16.8736 21.4265C16.097 21.1048 15.4333 20.5601 14.9663 19.8612C14.4993 19.1623 14.25 18.3406 14.25 17.5V17C14.25 16.8011 14.329 16.6103 14.4697 16.4697C14.6103 16.329 14.8011 16.25 15 16.25C15.1989 16.25 15.3897 16.329 15.5303 16.4697C15.671 16.6103 15.75 16.8011 15.75 17V17.5C15.75 18.0439 15.9113 18.5756 16.2135 19.0278C16.5156 19.4801 16.9451 19.8325 17.4476 20.0407C17.9501 20.2488 18.5031 20.3033 19.0365 20.1972C19.5699 20.0911 20.0599 19.8291 20.4445 19.4445C20.8291 19.06 21.091 18.5699 21.1972 18.0365C21.3033 17.5031 21.2488 16.9501 21.0407 16.4476C20.8325 15.9451 20.4801 15.5156 20.0278 15.2135C19.5756 14.9113 19.0439 14.75 18.5 14.75H4C3.80109 14.75 3.61032 14.671 3.46967 14.5303C3.32902 14.3897 3.25 14.1989 3.25 14Z" fill="black"/>
            </svg>
            <div>
              Vitesse: {{ $store.getters.wind_speed }} km/h
            </div>
            </div>
          <div class="grey-area w-48 date-hour d-flex">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 2V10M10 10L6 6M10 10L14 6M12.8 21.6C13.0535 21.7901 13.3486 21.9173 13.6609 21.971C13.9732 22.0248 14.2938 22.0035 14.5963 21.909C14.8988 21.8145 15.1745 21.6495 15.4007 21.4276C15.6269 21.2056 15.7972 20.9331 15.8974 20.6325C15.9976 20.3318 16.0249 20.0117 15.9771 19.6984C15.9293 19.3851 15.8078 19.0877 15.6225 18.8306C15.4372 18.5735 15.1935 18.3641 14.9114 18.2197C14.6293 18.0753 14.3169 18 14 18H2M17.5 10C17.7557 9.65909 18.0943 9.38919 18.4836 9.21594C18.8729 9.04269 19.3001 8.97183 19.7245 9.0101C20.1489 9.04837 20.5565 9.1945 20.9086 9.4346C21.2606 9.6747 21.5455 10.0008 21.7361 10.382C21.9266 10.7631 22.0166 11.1867 21.9975 11.6124C21.9783 12.0381 21.8507 12.4518 21.6266 12.8143C21.4026 13.1768 21.0896 13.476 20.7174 13.6836C20.3452 13.8911 19.9261 14 19.5 14H2" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div>
              Direction: {{ $store.getters.wind_dir }} degré(s)
            </div>
          </div>
        </div>
      </div>
      <div class="mt-20px">
        <CustomRadioButton :values="detection" :valueDefault="results.detecte" justifyContent="flex-start" class="mt-10px"
          v-model="results.detecte"></CustomRadioButton>
        <div v-if="results.detecte === 'Détecté'">
          <h3 class="pl-8px">Intensité</h3>
          <CustomJauge class="mt-10px" v-model="results.intensity"></CustomJauge>
          <div class="error">{{ errors.intensity }}</div>
          <div class="mt-10px">
            <h3 class="pl-8px">Persistance de l'intensité</h3>
          </div>
          <CustomRadioButton :values="persistance" :valueDefault="results.persistence" class="mt-10px"
            v-model="results.persistence"></CustomRadioButton>
          <div class="error">{{ errors.persistence }}</div>
          <CustomSelect class="mt-10px" title="Description: Catégorie" :options="descriptionCategorie"
            v-model="results.category"></CustomSelect>
          <div class="error">{{ errors.category }}</div>
          <CustomSelect v-if="results.category" class="mt-10px" title="Description: Sous-catégorie"
            :options="descriptionSubcategorie[results.category]" v-model="results.subcategory"></CustomSelect>
          <div class="error" v-if="results.category">{{ errors.subcategory }}</div>
          <div class="mt-10px">
            <h3 class="pl-8px">Appréciation</h3>
          </div>
          <CustomRadioButton :values="appreciation" :valueDefault="results.assessment" class="mt-10px"
            v-model="results.assessment"></CustomRadioButton>
          <div class="error">{{ errors.assessment }}</div>
          <div class="mt-10px">
            <h3 class="pl-8px">Commentaires</h3>
          </div>
          <textarea placeholder="Ajouter un commentaire" class="input-form mt-10px" rows="7"
            v-model="results.comments"></textarea>
        </div>
        <button class="button-green mt-10px w-100" @click="saveForm(activePoint)" v-if="results.detecte">
          <custom-icon name="plus-circle"></custom-icon>Valider le questionnaire
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import CustomIcon from "@/components/CustomIcon.vue";
import CustomJauge from "@/components/customForm/CustomJauge.vue";
import CustomSelect from "@/components/customForm/CustomSelect.vue";
import CustomRadioButton from "@/components/customForm/CustomRadioButton.vue";
import imgNez from "@/assets/images/icon_odeur_detecte_default.png";
import imgNezFalse from "@/assets/images/icon_odeur_non_detecte_default.png";

import imgNezActive from "@/assets/images/icon_odeur_detecte.png";
import imgNezFalseActive from "@/assets/images/icon_odeur_non_detecte.png";

import imgPonctuelle from "@/assets/images/ponctuelle.png";
import imgVariable from "@/assets/images/variable.png";
import imgContinue from "@/assets/images/continue.png";
import imgAgreable from "@/assets/images/agreable.png";
import imgNeutre from "@/assets/images/neutre.png";
import imgDesagreable from "@/assets/images/desagreable.png";
import imgPonctuelleActive from "@/assets/images/ponctuelleActive.png";
import imgVariableActive from "@/assets/images/variableActive.png";
import imgContinueActive from "@/assets/images/continueActive.png";
import imgAgreableActive from "@/assets/images/agreableActive.png";
import imgNeutreActive from "@/assets/images/neutreActive.png";
import imgDesagreableActive from "@/assets/images/desagreableActive.png";
import utils from "@/mixins/utils";

import { openDB, updateSample } from "@/indexedDB";
export default {
  data() {
    return {
      displayDate: null,
      displayHour: null,
      results: {
        time: null,
        detecte: null,
        intensity: null,
        persistence: null,
        assessment: null,
        category: null,
        subcategory: null,
        comments: null,
        lat: null,
        lng: null,
        status: null,
        wind_dir:null,
        wind_speed:null
      },
      appreciation: [
        {
          img: imgAgreable,
          imgActive: imgAgreableActive,
          titre: "Agréable",
          value: "Agréable",
          color: "#EBF9F1",
        },
        {
          img: imgNeutre,
          imgActive: imgNeutreActive,
          titre: "Neutre",
          value: "Neutre",
          color: "#FBF2E2",
        },
        {
          img: imgDesagreable,
          imgActive: imgDesagreableActive,
          titre: "Désagréable",
          value: "Désagréable",
          color: "#FBE6E0",
        },
      ],
      detection: [
        {
          img: imgNezFalse,
          imgActive: imgNezFalseActive,
          titre: "Détecté",
          value: "Détecté",
          color: "#EBF9F1",
        },
        {
          img:  imgNez,
          imgActive: imgNezActive,
          titre: "Non-détecté",
          value: "Non-détecté",
          color: "#FBE6E0",
        },
      ],
      persistance: [
        {
          img: imgPonctuelle,
          imgActive: imgPonctuelleActive,
          titre: "Ponctuelle",
          value: "Ponctuelle",
          color: "#EBF9F1",
        },
        {
          img: imgVariable,
          imgActive: imgVariableActive,
          titre: "Variable",
          value: "Variable",
          color: "#FBF2E2",
        },
        {
          img: imgContinue,
          imgActive: imgContinueActive,
          titre: "Continue",
          value: "Continue",
          color: "#FBE6E0",
        },
      ],
      descriptionCategorie: [
        {
          label: "Fragrance",
          value: "Fragrance",
        },
        {
          label: "Résineux boisé",
          value: "Résineux boisé",
        },
        {
          label: "Fruité (sauf agrume)",
          value: "Fruité (sauf agrume)",
        },
        {
          label: "Dégoutant 1",
          value: "Dégoutant 1",
        },
        {
          label: "Chimique",
          value: "Chimique",
        },
        {
          label: "Menthe poivrée",
          value: "Menthe poivrée",
        },
        {
          label: "Sucré",
          value: "Sucré",
        },
        {
          label: "Pop-corn",
          value: "Pop-corn",
        },
        {
          label: "Dégoutant 2",
          value: "Dégoutant 2",
        },
        {
          label: "Agrume",
          value: "Agrume",
        },
      ],
      descriptionSubcategorie: {
        Fragrance: [
          {
            label: "Floral",
            value: "Floral",
          },
          {
            label: "Sucré",
            value: "Sucré",
          },
          {
            label: "Rose",
            value: "Rose",
          },
          {
            label: "Végétal",
            value: "Végétal",
          },
          {
            label: "Vert",
            value: "Vert",
          },
          {
            label: "Herbe fraîchement coupée",
            value: "Herbe fraîchement coupée",
          },
          {
            label: "Autre",
            value: "Autre",
          },
        ],
        "Résineux boisé": [
          {
            label: "Moisissure",
            value: "Moisissure",
          },
          {
            label: "Terre",
            value: "Terre",
          },
          {
            label: "Décomposé",
            value: "Décomposé",
          },
          {
            label: "Cèdre",
            value: "Cèdre",
          },
          {
            label: "Végétal",
            value: "Végétal",
          },
          {
            label: "Herbe fraîchement coupée",
            value: "Herbe fraîchement coupée",
          },
          {
            label: "Fumé",
            value: "Fumé",
          },
          {
            label: "Brûlé",
            value: "Brûlé",
          },
          {
            label: "Autre",
            value: "Autre",
          },
        ],
        "Fruité (sauf agrume)": [
          {
            label: "Sucré",
            value: "Sucré",
          },
          {
            label: "Autre",
            value: "Autre",
          },
        ],
        "Dégoutant 1": [
          {
            label: "Putride",
            value: "Putride",
          },
          {
            label: "Infect",
            value: "Infect",
          },
          {
            label: "Pourri",
            value: "Pourri",
          },
          {
            label: "Rance",
            value: "Rance",
          },
          {
            label: "Sueur",
            value: "Sueur",
          },
          {
            label: "Sur",
            value: "Sur",
          },
          {
            label: "Vinaigre",
            value: "Vinaigre",
          },
          {
            label: "Matière fécale",
            value: "Matière fécale",
          },
          {
            label: "Lait caillé",
            value: "Lait caillé",
          },
          {
            label: "Moisissure",
            value: "Moisissure",
          },
          {
            label: "Terre",
            value: "Terre",
          },
          {
            label: "Décomposé",
            value: "Décomposé",
          },
          {
            label: "Autre",
            value: "Autre",
          },
        ],
        Chimique: [
          {
            label: "Peinture",
            value: "Peinture",
          },
          {
            label: "Liquide de nettoyage",
            value: "Liquide de nettoyage",
          },
          {
            label: "Alcool",
            value: "Alcool",
          },
          {
            label: "Autre",
            value: "Autre",
          },
        ],
        "Menthe poivrée": [
          {
            label: "Épicé",
            value: "Épicé",
          },
          {
            label: "Sucré",
            value: "Sucré",
          },
          {
            label: "Autre",
            value: "Autre",
          },
        ],
        Sucré: [
          {
            label: "Autre",
            value: "Autre",
          },
        ],
        "Pop-corn": [
          {
            label: "Fumé",
            value: "Fumé",
          },
          {
            label: "Brulé",
            value: "Brulé",
          },
          {
            label: "Boisé",
            value: "Boisé",
          },
          {
            label: "Fumé",
            value: "Fumé",
          },
          {
            label: "Fumé",
            value: "Fumé",
          },
        ],
        "Dégoutant 2": [
          {
            label: "Ail",
            value: "Ail",
          },
          {
            label: "Oignon",
            value: "Oignon",
          },
          {
            label: "Fumé",
            value: "Fumé",
          },
          {
            label: "Brûlé",
            value: "Brûlé",
          },
          {
            label: "Acide",
            value: "Acide",
          },
          {
            label: "Gaz naturel",
            value: "Gaz naturel",
          },
          {
            label: "Putride",
            value: "Putride",
          },
          {
            label: "Infect",
            value: "Infect",
          },
          {
            label: "Pourri",
            value: "Pourri",
          },
          {
            label: "Égout",
            value: "Égout",
          },
          {
            label: "Caoutchouc ",
            value: "Caoutchouc ",
          },
          {
            label: "Brûlé",
            value: "Brûlé",
          },
          {
            label: "Autre",
            value: "Autre",
          },
        ],
        Agrume: [
          {
            label: "Végétal",
            value: "Végétal",
          },
          {
            label: "Herbe fraîchement coupée",
            value: "Herbe fraîchement coupée",
          },
          {
            label: "Herbe fraîchement coupée",
            value: "Herbe fraîchement coupée",
          },
        ],
      },
      errors: {

      }
    };
  },
  mixins: [utils],
  props: {
    activePoint: Object,
  },
  components: {
    CustomIcon,
    CustomJauge,
    CustomRadioButton,
    CustomSelect,
  },
  methods: {
    cancel() {
      this.$emit("cancel", false);
    },
    async saveForm(activePoint) {
      let pointToUpdate = activePoint
      this.errors = {}
      let submit = true
      if(this.results.detecte==='Détecté'){
        if (!this.results.intensity) {
          this.errors.intensity = 'Vous devez indiquer une intensité'
          submit = false
        }
        if (!this.results.persistence) {
          this.errors.intensity = 'Vous devez indiquer une persistence'
          submit = false
        }
        if (!this.results.category) {
          this.errors.category = 'Vous devez indiquer une categorie'
          submit = false
        }
        if (!this.results.subcategory) {
          this.errors.subcategory = 'Vous devez indiquer une sous-categorie'
          submit = false
        }
        if (!this.results.assessment) {
          this.errors.assessment = 'Vous devez indiquer une appréciation'
          submit = false
        }
      }
      else{
        this.results.intensity=null
        this.results.persistence=null
        this.results.category=null
        this.results.subcategory=null
        this.results.assessment=null
      }
      if (submit) {
        this.getPosition((position) => {
          this.results.lat = position.coords.latitude
          this.results.lng = position.coords.longitude
        })
        try {
          this.results.wind_dir = this.$store.getters.wind_dir
          this.results.wind_speed = this.$store.getters.wind_speed
          this.results.status = 2
          this.results.status_reason = null
          await openDB();
          await updateSample(pointToUpdate.properties.id, this.results);
          await this.changeUpdateDate(this.results)
          this.$emit("cancel", false);
        } catch (error) {
          console.log(error)
        }
       
      }
    }
  },
  mounted() {
    this.results.time = new Date()
    let month = this.results.time.getMonth() + 1
    this.displayDate = this.results.time.getFullYear() + '-' + month + '-' + this.results.time.getDate()
    this.displayHour = this.results.time.getHours() + ':' + this.results.time.getMinutes()
    this.results.detecte = this.activePoint.properties.detecte
    this.results.intensity = this.activePoint.properties.intensity
    this.results.persistence = this.activePoint.properties.persistence
    this.results.assessment = this.activePoint.properties.assessment
    this.results.category = this.activePoint.properties.category
    this.results.campaignUUID = this.activePoint.properties.campaignUUID
    this.results.subcategory = this.activePoint.properties.subcategory
    this.results.comments = this.activePoint.properties.comments
    this.results.status = this.activePoint.properties.status
    this.results.wind_dir = this.$store.getters.wind_dir
    this.results.wind_speed = this.$store.getters.wind_speed
    this.getPosition((position) => {
      this.results.lat = position.coords.latitude
      this.results.lng = position.coords.longitude
    })
  }
};
</script>
<style scoped>
.odor-form-container {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 5000;
  height: 100vh;
  width: 100vw;
  background-color: white;
  overflow-y: scroll;
}

.odor-form-container h2 {
  color: #313030;
  font-size: 20px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
}

.localisation-container {
  background: #f4f8fd;
  padding: 8px;
}

.grey-area {
  margin-top: 15px;
  border-radius: 8px;
  background: #edecec;
  padding: 8px 12px 8px 12px;
}

h3 {
  margin-top: 2px;
  margin-bottom: 2px;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.date-hour {
  color: #313030;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: center;
}

.address {
  color: #313030;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>
